import {UUID_NULL} from '../constants/defaultValues'
import {SET_SYSTEM, SENDING_ALL_SYSTEM_REQUEST, FETCH_ALL_SYSTEM_SUCCESS, FETCH_ALL_SYSTEM_FAILURE} from '../actions/constants'

const initialState = {
  currentSystem: {
    ID: UUID_NULL,
    Name: 'default',
    HardwareType: 0,
    Description: '',
    Logo: ''
  },
  systems: [],
  error: '',
  fetching: false
}

const system = (state = initialState, action) => {
  switch (action.type) {
    case SET_SYSTEM:
      return {
        ...state,
        currentSystem: action.newSystemState
      }
    case SENDING_ALL_SYSTEM_REQUEST:
      return {
        ...state,
        fetching: action.sending
      }
    case FETCH_ALL_SYSTEM_SUCCESS:
      return {
        ...state,
        systems: action.systems
      }
    case FETCH_ALL_SYSTEM_FAILURE:
      return {
        ...state,
        error: action.error
      }
    default:
      return state
  }
}

export default system



// WEBPACK FOOTER //
// ./src/reducers/system.js